import React, { Component } from "react";
import ScrollToTop from "react-scroll-up";


class ToTopButton extends Component {
  render() {
    return (
      <ScrollToTop 
      showUnder={160} 
      style={{
        position: 'fixed',
        bottom: 50,
        right: 30,
        height:40,
        width:40,
        cursor: 'pointer',
        transitionDuration: '0.2s',
        transitionTimingFunction: 'linear',
        transitionDelay: '0s',
        backgroundColor: 'rgba(50, 50, 50, 0.5)',
        borderRadius: '50%',
        }}>
        <svg viewBox="0 0 32 32" 
        style={{
          display: 'inline-block',
          width: '100%',
          height: '100%',
          strokeWidth: 0,
          stroke: 'white',
          fill: 'white',
          paddingLeft: 11,
          paddingBottom: 2
        }}>
          <path d="M19.196 23.429q0 0.232-0.179 0.411l-0.893 0.893q-0.179 0.179-0.411 0.179t-0.411-0.179l-7.018-7.018-7.018 7.018q-0.179 0.179-0.411 0.179t-0.411-0.179l-0.893-0.893q-0.179-0.179-0.179-0.411t0.179-0.411l8.321-8.321q0.179-0.179 0.411-0.179t0.411 0.179l8.321 8.321q0.179 0.179 0.179 0.411zM19.196 16.571q0 0.232-0.179 0.411l-0.893 0.893q-0.179 0.179-0.411 0.179t-0.411-0.179l-7.018-7.018-7.018 7.018q-0.179 0.179-0.411 0.179t-0.411-0.179l-0.893-0.893q-0.179-0.179-0.179-0.411t0.179-0.411l8.321-8.321q0.179-0.179 0.411-0.179t0.411 0.179l8.321 8.321q0.179 0.179 0.179 0.411z"></path>
        </svg>
      </ScrollToTop>
    );
  }
}

export default ToTopButton;



// WEBPACK FOOTER //
// ./src/components/ToTopButton/ToTopButton.jsx